var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { equal, not, alias } from '@ember/object/computed';
import { set } from '@ember/object';
import { attr } from '@ember-data/model';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Enum from '@square/dashboard-utilities/utils/enum';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
export const VendorState = new Enum(['VENDOR_DO_NOT_USE', 'VENDOR_ACTIVE', 'VENDOR_INACTIVE']);
let Vendor = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = fragment('squareup/common/location/global-address-ed'), _dec5 = alias('contacts.firstObject.name'), _dec6 = alias('contacts.firstObject.emailAddress'), _dec7 = alias('contacts.firstObject.phoneNumber'), _dec8 = attr('string'), _dec9 = attr('string'), _dec10 = attr('enum', {
  enumClass: VendorState
}), _dec11 = attr('number'), _dec12 = attr('number'), _dec13 = attr('number'), _dec14 = fragmentArray('squareup/inventory/v3/vendor-contact'), _dec15 = equal('state', VendorState.VENDOR_ACTIVE), _dec16 = not('isActive'), _class = (_class2 = class Vendor extends EmberDataBaseModel {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "token", _descriptor3, this);
    _initializerDefineProperty(this, "name", _descriptor4, this);
    _initializerDefineProperty(this, "addressToken", _descriptor5, this);
    _initializerDefineProperty(this, "address", _descriptor6, this);
    _initializerDefineProperty(this, "contactName", _descriptor7, this);
    _initializerDefineProperty(this, "email", _descriptor8, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor9, this);
    _initializerDefineProperty(this, "accountNumber", _descriptor10, this);
    _initializerDefineProperty(this, "notes", _descriptor11, this);
    _initializerDefineProperty(this, "state", _descriptor12, this);
    _initializerDefineProperty(this, "createdAt", _descriptor13, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor14, this);
    _initializerDefineProperty(this, "version", _descriptor15, this);
    _initializerDefineProperty(this, "contacts", _descriptor16, this);
    _initializerDefineProperty(this, "isActive", _descriptor17, this);
    _initializerDefineProperty(this, "isDisabled", _descriptor18, this);
  }
  init(...args) {
    super.init(...args);
    if (!this.address) {
      this.set('address', this.store.createFragment('squareup/common/location/global-address-ed'));
    }
    if (!this.address.countryCode) {
      // NB(seanluong): We disable the linting rule to import `appCurrentUser` so that we can use the current user's
      // country code as the default for the address. It's no longer correct to use 'US' because we have launched
      // products in several other countries, and using 'US' could lead to some parts of Dashboard making incorrect
      // assumptions regarding vendor addresses, which could result in unstable behavior.
      this.address.set('countryCode', this.userInfo.countryCode);
    }
    if (isEmpty(this.contacts)) {
      this.contacts.createFragment({});
    }
  }
  beforeSave() {
    // remove the contact if it is both new and removed
    // or if contact is removed and has no token
    set(this, 'contacts', this.contacts.reject(contact => contact.isNew && contact.isRemoved || !contact.token && contact.isRemoved));
    this.contacts.forEach((contact, index) => {
      if (contact.isRemoved) {
        contact.set('removed', true);
      }
      contact.set('ordinal', index);
    });
    if (this.isNew) {
      // for new vendors we want to clean up the whitespace before sending to server
      this.name = this.name.trim();
    }
  }
  save() {
    this.beforeSave();
    return super.save();
  }
}, _defineProperty(_class2, "url", '/api/v2/inventory/vendors'), _defineProperty(_class2, "_modelNameForMigration", 'squareup/inventory/v3/vendor'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "token", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "addressToken", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "address", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "contactName", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "email", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "accountNumber", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "state", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "version", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "contacts", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "isActive", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "isDisabled", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Vendor as default };